module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/nz-37be84f4206a0eae405bbd495ecaaa69.svg";